import Preview from "./Preview/Preview";
import {ActionSetDefinition} from "../ActionSetView";

export default {
    id:"Accordion",
    parent:{name:"View"},
    preview:{
        position:"bottom",
        component:Preview,
    },
    cssvars:[
        {name:"paddingHorizontal",type:"3.733em"},
        {name:"borderRadius",type:"1.1em"},
    ],
    props:[
        {
            name:"title",
            type:"string",
            description:"default header title",
        },
        {
            name:"headerStyle",
            type:"string",
            description:"header container style",
        },
        {
            name:"containerClassName",
            type:"string",
            description:"Content container className, when separate is true, specify a paddingTop value to get the desired behavior ",
        },
        {
            name:"renderHeader",
            type:"(props:{parent:HTMLElement}):HTMLElement",
            description:"custom header generation function",
        },
        {
            name:"renderContent",
            type:"(props:{parent:HTMLElement}):HTMLElement",
            description:"",
        },
        {
            name:"memorize",
            type:"boolean",
            description:"if true, renderContent is called once, using the returned HTMLElement for next renders",
            defaultvalue:"true",
        },
        {
            name:"indicator",
            type:`string | (color="black",weight=1) => string`,
            description:"default header indicator icon as url/base64 string or function",
        },
        {
            name:"separate",
            type:"boolean",
            description:"Specifies if the content view will be connected to the header or not, to remove header bottom-border-radius when open",
            defaultvalue:"false",
        },
        {
            name:"open",
            type:"boolean",
            defaultValue:false,
        },
        {
            name:"locked",
            type:"boolean",
            description:"if true, prevents accordion opening ",
            defaultvalue:"false",
        },
        {
            name:"actions",
            type:{
                hash:"ActionSetView",
                name:"ActionSetDefinition[]",
            },
            description:"actions of the default header ActionsSetView",
            props:[ActionSetDefinition],
        },
        {
            name:"tintColor",
            type:"string",
            description:"title, indicator and actions color of the default header",
        },
        {
            name:"onOpen",
            type:"(container:HTMLElement):void",
            description:"called when Accordion is opened",
        },
        {
            name:"onClose",
            type:"(container:HTMLElement):void",
            description:"called when Accordion is closed",
        },
    ],
    properties:[
        {
            name:"header",
            type:"HTMLElement|null",
            description:"gets the element returned by renderHeader",
        },
        {
            name:"content",
            type:"HTMLElement|null",
            description:"gets the element returned by renderContent",
        },
        {
            name:"isLocked",
            type:"boolean",
            description:"Locks and unlocks the accordion",
        },
        {
            name:"toggle",
            type:"(open?:boolean):void",
            description:"opens and closes the accordion",
            props:[
                {
                    name:"open",
                    type:"boolean",
                    description:"default: toggling behavior, true if closed, false if open"
                },
            ],
        },
    ],
}
